import styled, { FlattenSimpleInterpolation, css } from 'styled-components';

import { Color, FontWeight } from '../../enums';
import { StyledComponent } from '../../interfaces';
import { LoadingSpinner } from '../loadingSpinner/loadingSpinner.component';
import { MenuPosition } from '../menuPosition/menuPosition.component';

import { TableCellProps, TableRowProps, TableWrapperProps } from './elementsTable.types';

export const Container: StyledComponent<'div'> = styled.div`
  max-width: 100%;
  width: 100%;
`;

export const TableWrapper: StyledComponent<'div', TableWrapperProps> = styled.div<TableWrapperProps>`
  position: relative;

  ${({ $isLoading }: TableWrapperProps): FlattenSimpleInterpolation => $isLoading ? css`
    :after {
      content: '';
      width: 100%;
      height: 100%;
      position: absolute;
      top: 0;
      left: 0;
      background-color: ${Color.Black};
      opacity: 0.2;
    }
  ` : css``}
`;

export const Table: StyledComponent<'table'> = styled.table`
  margin-bottom: 20px;
  width: 100%;
`;

export const TableHeader: StyledComponent<'thead'> = styled.thead`
  background-color: ${Color.Gray100};
  font-weight: ${FontWeight.Bold};
  font-size: 12px;
  line-height: 16px;
  letter-spacing: 0.1em;
  text-transform: uppercase;
`;

export const TableCell: StyledComponent<'td', TableCellProps> = styled.td<TableCellProps>`
  padding: ${({ $isHeaderCell }: TableCellProps): string => $isHeaderCell ? '26px 16px 14px' : '19px 16px'};
  color: ${Color.Black};
  vertical-align: middle;

  :last-of-type {
    text-align: ${({ $isLastWithRightAlign }: TableCellProps): string => $isLastWithRightAlign ? 'right' : 'left'};
  }
`;

export const TableBody: StyledComponent<'tbody'> = styled.tbody`
  font-size: 14px;
  line-height: 18px;
  word-break: break-word;
`;

export const ArrowsContainer: StyledComponent<'div'> = styled.div`
  display: flex;
  flex-direction: column;
  opacity: 0;
  transition: .3s;
`;

export const TableRow: StyledComponent<'tr', TableRowProps> = styled.tr<TableRowProps>`
  border-bottom: 1px solid ${Color.Gray300};
  cursor: default;

   &:first-of-type {
      background-color: ${({ $isFirstHover }: TableRowProps): Color => $isFirstHover ? Color.Gray100 : Color.Transparent};

      ${ArrowsContainer} {
        opacity: ${({ $isFirstHover }: TableRowProps): string => $isFirstHover ? '1' : '0'};
      }
    }

  &:hover {
    background-color: ${Color.Gray100};

    ${ArrowsContainer} {
      opacity: 1;
    }
  }
`;

export const CellWithArrows: StyledComponent<'div'> = styled.div`
  display: flex;
  justify-content: space-between;
  align-items: center;
  min-width: 150px;
`;

export const ArrowButton: StyledComponent<'button'> = styled.button.attrs({ type: 'button' })`
  display: flex;
  align-items: center;
  justify-content: center;

  & + & {
    margin-top: 10px;
  }
`;

export const StyledLoadingSpinner: StyledComponent<typeof LoadingSpinner> = styled(LoadingSpinner)`
  position: absolute;
  top: 50%;
  left: 50%;
  transform: translate(-50%, -50%);
  margin: 0;
  background: ${Color.White};
`;

export const Link: StyledComponent<typeof MenuPosition> = styled(MenuPosition)`
  padding: 8px 20px;
  text-decoration: none;
  color: ${Color.Black};
  font-weight: ${FontWeight.Medium};
  font-size: 14px;
  line-height: 18px;
  border: 1px solid ${Color.Black};
  display: inline-block;
`;
